import React from 'react';
import { Badge } from '@chakra-ui/react';

interface BadgeCfg {
  label: string;
  color: string;
  bg: string;
}

const MAP: Record<string, BadgeCfg> = {
  ATRASADO: { label: 'Vencido', color: '#DC2626', bg: 'rgba(220, 38, 38, 0.12)' },
  PERDIDO: { label: 'Perdido', color: '#B91C1C', bg: 'rgba(185, 28, 28, 0.12)' },
  PAGO: { label: 'Pago', color: '#16A34A', bg: 'rgba(22, 163, 74, 0.12)' },
  RECEBIDO: { label: 'Recebido', color: '#16A34A', bg: 'rgba(22, 163, 74, 0.12)' },
  RECEBIDO_PARCIAL: { label: 'Parcial', color: '#0EA5E9', bg: 'rgba(14, 165, 233, 0.12)' },
  PARCIAL: { label: 'Parcial', color: '#0EA5E9', bg: 'rgba(14, 165, 233, 0.12)' },
  EM_ABERTO: { label: 'Em aberto', color: '#1B88F5', bg: 'rgba(27, 136, 245, 0.12)' },
  PENDENTE: { label: 'Pendente', color: '#1B88F5', bg: 'rgba(27, 136, 245, 0.12)' },
};

export const StatusBadge = ({ status }: { status?: string | null }) => {
  const key = (status ?? '').toUpperCase();
  const cfg: BadgeCfg = MAP[key] ?? {
    label: status || '—',
    color: '#71717A',
    bg: 'rgba(113, 113, 122, 0.12)',
  };
  return (
    <Badge
      style={{ color: cfg.color, backgroundColor: cfg.bg }}
      borderRadius="full"
      px={2}
      py="2px"
      fontWeight={600}
      textTransform="none"
    >
      {cfg.label}
    </Badge>
  );
};
